module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/magazine/section04_06_american-village-80a80e1f67be3bc8dd584aec4fae50f0.jpg";